import React from 'react';

export interface DataGridEmptyProps {
  title?: string;
  description?: string;
}

/**
 * Default empty state for a DataGrid. Centred, muted text inside a bordered
 * container that matches the loaded-table chrome.
 */
export const DataGridEmpty = ({
  title = 'No results',
  description = 'Try adjusting your filters or search.',
}: DataGridEmptyProps): React.JSX.Element => (
  <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
    <p className="text-sm font-medium text-[var(--fg)]">{title}</p>
    <p className="mt-1 max-w-sm text-sm text-[var(--fg-muted)]">{description}</p>
  </div>
);
